import { useTranslation } from "react-i18next";
import { AuthShell, EmailPasswordForm } from "@/pages/Login";

// ADMINISTRATION login — dedicated enterprise entry point. Reuses the EXACT
// existing email/password form (EmailPasswordForm) and the same auth logic; no
// new form, API, validation, service or middleware is introduced here.
export default function AdminLogin() {
  const { t } = useTranslation();
  return (
    <AuthShell title={t("auth.signInTitle")}>
      <div data-testid="admin-login-page" className="space-y-2">
        <p className="text-sm text-muted-foreground mb-4" data-testid="admin-login-subtitle">
          Administration access
        </p>
        <EmailPasswordForm />
      </div>
    </AuthShell>
  );
}
